export const PHONE_NUMBER_REG = /^(1[3-9])\d{9}$/;
export const LOGIN_VERIFY_CODE_REG=/^\d{6}$/;
export const EMPTY_REG=/(^\s+)|(\s+$)|\s/g;